export default {
  title: 'Thank you for completing Open Banking.',
  firstParagraph:
    'Your broker can now continue to the application. They will get in contact with you directly for any other requirements.',
  secondParagraph: 'You can now close this window.'
};
